/* eslint-disable */
export enum LinkTarget {
  BLANK = '_blank',
  SELF = '_self',
  PARENT = '_parent',
  TOP = '_top',
  FRAMENAME = 'framename',
}
export enum Theme {
  PURPLE = 'theme-purple',
  BLUE = 'theme-blue',
  ORANGE = 'theme-orange',
  GREEN = 'theme-green',
  RED = 'theme-red',
  YELLOW = 'theme-yellow',
  SUCCESS = 'theme-success',
  ERROR = 'theme-error',
  WARNING = 'theme-warning',
  ACTION = 'theme-action',
  GRAY = 'theme-gray',
  BLACK = 'theme-black',
  WHITE = 'theme-white',
}

export enum MLPVersion {
  ONE = 'one',
  TWO = 'two',
}

export enum TabLayout {
  HORIZONTAL = 'horizontal',
  STACKED = 'stacked',
}
export enum SelectorType {
  CIRCLE = 'circle',
  UNDERLINE = 'underline',
}
export enum TabDesign {
  DEFAULT = 'white',
  TRANSPARENT = 'transparent',
  SOLID = 'solid',
  THEMED = 'light',
  PILL = 'pill',
  ICON_CIRCLE = 'icon-circle',
}

export enum TextWeight {
  REGULAR = 'regular-weight',
  MULTI = 'multi-weight',
  BOLD = 'bold',
}

export enum TextLinkUnderlineStyle {
  HOVER = 'UnderlineOnHover',
  NOHOVER = 'NoUnderlineOnHover',
  FIXED = 'UnderlineFixed',
}

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum Status {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum FrameworkRole {
  ADMIN = 'ADMIN',
  MEMBER = 'MEMBER',
}

export enum AdminType {
  SUPERADMIN = '1',
  CHALLENGE = '2',
  PROMOTION = '3',
}

export enum MemberType {
  INDIVIDUAL = 'INDIVIDUAL',
  COUPLE = 'COUPLE',
  INVISIBLE = 'INDIVIDUAL_INVISIBLE',
}

export enum ErrorType {
  COMING_SOON = 'coming-soon-mode',
  NOT_FOUND = 'not-found-mode',
  NO_RESULT = 'no-result-mode',
  NO_RECORD = 'no-record-mode',
  NO_REWARD_AVAILABLE = 'no-reward-mode',
}

export enum Position {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export enum ImageEditorSize {
  INHERIT_SIZE = 'inherit-size',
  FIXED_SIZE = 'fixed-size',
  FIXED_HEIGHT = 'fixed-height',
}

export enum CalendarWidth {
  DEFAULT = 'default-width',
  FULL_WIDTH = 'full-width',
}

export enum DatePickerType {
  DROP_DOWN = 'dropdown',
  MODAL = 'modal',
}

export enum TimePickerModal {
  NONE = 'none',
  START_TIME = 'start-time',
  END_TIME = 'end-time',
}

export enum PrimaryButtonLabel {
  APPLY = 'Apply',
  CLEAR = 'Clear',
}

export enum TimeMeridiem {
  AM = 'AM',
  PM = 'PM',
}

export enum Language {
  English = 'en-my',
  Indonesian = 'id-id',
  Malay = 'ms',
  Chinese = 'zh',
}

export enum ActionType {
  ELLIPSE_MENU = 'ellipse-menu',
  SINGLE_ACTION_ICON = 'single-action-icon',
  TWO_ACTION_ICON = 'two-action-icon',
}

export enum Country {
  MY = 'MY',
  IDN = 'ID'
}

export enum CampaignProgressStatus {
  COMPLETED = 'Completed',
  NOT_COMPLETED = 'Not Completed'
}

export enum EnrollmentType {
  PARTICIPANT = 'PARTICIPANT',
  COACH = 'COACH',
  LEADER = 'LEADER'
}

export enum RewardStatus {
  SELECTED = 'SELECTED',
  ALLOCATED = 'ALLOCATED',
  DISTRIBUTED = 'DISTRIBUTED'
}
